module.exports = __webpack_public_path__ + "img/warehouse-management.a1b35ba2.png";